import { useInfiniteQuery, useQuery } from 'react-query'
import { getMonyPoolsDetailTransactions } from 'services/fund'

export default function useGetTransactions(
    id: string | undefined,
    searchTransaction: string
) {
    const { data, isLoading } = useQuery(
        ['money-pools-transactions', id, searchTransaction],
        getMonyPoolsDetailTransactions
    )

    return { data, isLoading }
}
